<template>
  <div class="mobile-hulu-course-carousel">
    <div class="mobile-hulu-course-carousel__links">
      <div class="mobile-hulu-course-carousel__link-wrapper">
        <router-link
          class="mobile-hulu-course-carousel__link"
          :to="{ name: 'allCourses', params: { name: route } }"
        >
          <span
            class="material-icons mobile-hulu-course-carousel__carousel-icon"
            >{{ icon }}</span
          >
          {{ title }}
        </router-link>
      </div>
    </div>
    <swiper
      class="swiper-container mobile-hulu-course-carousel__swiper-container"
      :options="swiperOption"
    >
      <swiper-slide
        v-for="course in courses"
        :key="course.id"
        class="swiper-slide mobile-hulu-course-carousel__tile"
        :style="
          `background-image: url(${$getCourseBackground(
            course,
            'small'
          )}), linear-gradient(${$getGradient()})`
        "
      >
        <router-link
          :to="{ name: 'course', params: { id: course.id, slug: course.slug } }"
          class="mobile-hulu-course-carousel__course-link"
        >
          <div class="mobile-hulu-course-carousel__overlay"></div>
          <div class="mobile-hulu-course-carousel__details">
            <div class="mobile-hulu-course-carousel__title">
              {{ course.title }}
            </div>
            <div class="mobile-hulu-course-carousel__instructor">
              <p class="mobile-hulu-course-carousel__lead">Instructor</p>
              <p class="mobile-hulu-course-carousel__name">
                {{
                  course.presenter && course.presenter.full_name !== ''
                    ? course.presenter.full_name
                    : getPresenter(course)
                }}
              </p>
            </div>
            <div class="mobile-hulu-course-carousel__branding">
              {{ course.track.vendor.title }}
            </div>
          </div>
        </router-link>
      </swiper-slide>
      <div
        class="swiper-button-prev"
        style="background: none;"
        slot="button-prev"
      >
        <i class="material-icons mobile-left-advance-carousel"
          >keyboard_arrow_left</i
        >
      </div>
      <div
        class="swiper-button-next"
        style="background: none; right: 20px;"
        slot="button-next"
      >
        <i class="material-icons mobile-right-advance-carousel"
          >keyboard_arrow_right</i
        >
      </div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'MobileHuluCourseCarousel',
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        freeMode: true,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          disabledClass: 'swiper-button-disabled',
        },
      },
    }
  },
  props: {
    courses: {
      type: [Array, Object],
      required: true,
    },
    presenters: {
      type: [Array, Object],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    route: {
      type: String,
      required: true,
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
  methods: {
    getPresenter(course) {
      const presenter = this.presenters.filter(
        aPresenter => aPresenter.id === course.instructor_id
      )[0]
      return presenter ? presenter.full_name : 'Unknown'
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile-hulu-course-carousel {
  padding-right: 0;
  padding-bottom: 50px;
  &__link-wrapper {
    margin-left: 15px;
    margin-bottom: 10px;
  }
  &__link {
    color: var(--white);
    font-size: 1.3rem;
    transition: all 0.5s ease;
    text-decoration: none;
    &:hover {
      color: var(--orange);
    }
  }
  &__carousel-icon {
    color: var(--orange);
    font-size: 1.3rem;
    margin-right: 5px;
  }
  &__swiper-container {
    padding: 10px;
    background-color: var(--light-gray);
  }
  &__overlay {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    right: 0;
    top: 0;
    z-index: 0;
    opacity: 0;
    transition: 0.5s all ease;
  }
  &__tile {
    text-align: left;
    padding: 10px;
    height: 250px;
    color: var(--white);
    position: relative;
    background-color: var(--orange);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    &:hover {
      cursor: pointer;
      .mobile-hulu-course-carousel__overlay {
        opacity: 1;
      }
    }
  }
  &__course-link {
    color: var(--white);
    text-decoration: none;
    height: 100%;
    z-index: 1;
    &:hover {
      color: var(--white);
      text-decoration: none;
    }
  }
  &__details {
    width: 100%;
    padding: 30px;
  }
  &__title {
    font-size: 1.4rem;
    font-weight: 700;
    width: 230px;
    position: absolute;
  }
  &__instructor {
    position: absolute;
    bottom: 10%;
    left: 8%;
  }
  &__lead {
    color: var(--gray);
    text-transform: uppercase;
    margin: 0;
    font-size: 0.8rem;
    font-weight: 500;
  }
  &__name {
    color: var(--white);
    font-weight: 700;
    margin: 0;
  }
  &__branding {
    font-weight: 700;
    font-size: 0.8rem;
    position: absolute;
    right: 10%;
    bottom: 10%;
    text-transform: uppercase;
  }
  .swiper-button-disabled {
    display: none;
  }
}
</style>
